import {ILeafNode} from "@feature/nodes/models/node-type";
import { RendererFunction } from '../types/renderer-function';
import {DownloadableNoticeboardAttachmentFile} from "../models/downloadable-noticeboard-attachment-file";
import {DownloadableFileComponent} from "@feature/_app_modules/composite-details/components/downloadable-file.component";
import {DownloadableNoticeboardAttachmentComponent} from "@feature/_app_modules/composite-details/components/downloadable-noticeboard-attachment.component";

export const downloadableNoticeboardAttachmentFileRendererFunc : RendererFunction = (viewContainerRef, node) => {
    const component = viewContainerRef.createComponent(DownloadableNoticeboardAttachmentComponent);
    const currentnode = node as ILeafNode<DownloadableNoticeboardAttachmentFile>
    component.instance.displayName = currentnode.Props.DisplayName;
    component.instance.uri = currentnode.Props.DocumentCentreDocumentUri;
}
